import ParcelLabel from '@features/ParcelLabel/ui/ParcelLabel';

export default function ParcelLabelPage() {
  return <ParcelLabel />;
}
